export default "__VITE_ASSET__qUlwpURX__"